import { render } from "./NotificationTool.vue?vue&type=template&id=18557d18&scoped=true"
import script from "./NotificationTool.vue?vue&type=script&lang=js"
export * from "./NotificationTool.vue?vue&type=script&lang=js"

import "./NotificationTool.vue?vue&type=style&index=0&id=18557d18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18557d18"]])

export default __exports__